import { createContext, useContext } from 'react';
import { action, observable } from 'mobx';

type Optional<T> = {
  value: T;
  error: string;
};

const emptyValue = { error: '', value: '' };
class AdSetBudgetBid {
  @observable id = '';
  @observable isSubmitting = false;
  @observable editMode = false;
  @observable bidStrategy = '';

  @observable dailyBudget: Optional<string> = {
    value: '',
    error: ''
  };
  @observable actionsBid: Optional<string> = {
    value: '',
    error: ''
  };
  @observable factor: Optional<string> = {
    value: '',
    error: ''
  };

  @action init = (id: string, dailyBudget: number, actionsBid: number, bidStrategy: string) => {
    this.editMode = true;
    this.dailyBudget.value = (dailyBudget / 100).toString();
    this.actionsBid.value = actionsBid === null ? '' : (actionsBid / 100).toString();
    this.bidStrategy = bidStrategy;
    this.id = id ? id.toString() : '';
  };

  @action reset = () => {
    this.id = '';
    this.isSubmitting = false;
    this.editMode = false;
    this.dailyBudget = emptyValue;
    this.actionsBid = emptyValue;
    this.factor = emptyValue;
  };

  @action handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case 'dailyBudget':
        this.dailyBudget = {
          error: parseFloat(event.target.value) < 1 ? 'Budget must be higher than $1 or your ads may not deliver' : '',
          value: event.target.value.toString()
        };
        break;
      case 'actionsBid':
        this.actionsBid = {
          error: '',
          value: event.target.value
        };
        break;
      case 'budgetByFactor':
        this.factor = {
          error:
            parseFloat(event.target.value) > 5 || parseFloat(event.target.value) < 0.01
              ? 'Factor values should be between 0 and 5'
              : '',
          value: event.target.value
        };
        break;

      default:
        throw new Error('This field is not supported');
    }
  };

  validateBudgetInput(budget: number | null) {
    if (budget === 0) {
      return null;
    } else {
      return budget;
    }
  }
  @action getValuesBeforeUpdate = (ids: string[]) => {
    return {
      ids: ids,
      dailyBudget:
        Number(this.dailyBudget.value) > 0 ? Number(this.validateBudgetInput(Number(this.dailyBudget.value))) : null,
      actionsBid: Number(this.actionsBid.value) > 0 ? Number(this.actionsBid.value) : null
    };
  };

  @action getValuesBeforeUpdateByFactor = (ids: string[]) => {
    return {
      ids: ids,
      factor: Number(this.factor.value),
      actionsBid: Number(this.actionsBid.value) > 0 ? Number(this.actionsBid.value) : null
    };
  };
}

export const AdSetBudgetBidContext = createContext(new AdSetBudgetBid());

export const useAdSetBudgetBidContext = () => useContext(AdSetBudgetBidContext);

export default AdSetBudgetBid;
